import Axios from 'axios'

import { SERVER_BASE_URL } from './baseUrl'
export const faireReclamationAsVisiteur = async (token: string, payment_intent_id: string) => {
  try {
    const response = await Axios.post(
      `${SERVER_BASE_URL}api/reclamation/refuser-compte-rendu`,
      { payment_intent_id },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )
    return response.data
  } catch (error) {
    console.error('Erreur lors de la requête :', error)
    throw error
  }
}
